import { render, staticRenderFns } from "./article-tab.vue?vue&type=template&id=45ebdb10&"
import script from "./article-tab.vue?vue&type=script&lang=js&"
export * from "./article-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports